export const LOGIN = '/auth/login';
export const LOGOUT = '/auth/logout';

// campaign
export const GET_LIST_CAMPAIGNS = '/campaigns/list';
export const GET_CAMPAIGN_DETAIL = '/ajax/campaigns/detail';
export const CREATE_UPDATE_CAMPAIGN = '/ajax/campaigns/update';
export const DELETE_CAMPAIGN = '/ajax/campaigns/delete';
export const CHANGE_CAMPAIGN_STATUS = '/ajax/campaigns/change';

// member
export const GET_LIST_MEMBERS = '/list-account';
export const CREATE_MEMBER = '/create-account';
export const UPDATE_MEMBER = '/update-account';
export const DELETE_MEMBER = '/delete-account';
export const GET_ALL_PARTNERS = '/common/get_partners';
export const GET_ALL_ROLES = '/common/get_roles';
export const GET_STATUS_ACCOUNT = '/common/get_account_statuses';

// partner
export const GET_LIST_PARTNERS = '/partners/list';
export const ADD_PARTNER = '/ajax/partners/update';
export const UPDATE_PARTNER = '/ajax/partners/update';
export const DELETE_PARTNER = '/ajax/partners/delete';
export const PARTNER_STATUS_CHANGE = '/ajax/partners/change';
export const PARTNER_DETAIL = '/ajax/partners/detail';

// role
export const GET_LIST_ROLES = '/list-roles';
export const CREATE_ROLE = '/create-role';
export const UPDATE_ROLE = '/update-role';
export const DELETE_ROLE = '/delete-role';

// permision
export const GET_LIST_PERMISSIONS = '/list-permission';
export const CREATE_PERMISSION = '/create-permission';
export const UPDATE_PERMISSION = '/update-permission';
export const DELETE_PERMISSION = '/delete-permission';
export const GET_LIST_PERMISSION_GROUP = '/list-permission-group';

// campaign statistic
export const GET_DIMENSIONS = '/campaign_statistic/dimensions';
export const GET_METRICS = '/campaign_statistic/metrics';
export const GET_CAMPAIGNS = '/common/get_campaigns';
export const GET_BANNER_POPUP_TYPES = '/common/get_banner_popup_types';
export const GET_POSITIONS = '/common/get_positions';
export const GET_PLATFORMS = '/common/get_platforms';
export const GET_BANNERS = '/common/get_banners';
export const GET_POPUPS = '/common/get_popups';
export const GET_PARTNERS = '/common/get_partners';
export const GET_DATA_STATISTICS = '/campaign_statistic/data_statistics';
export const GET_GRAPHICAL_STATISTICS = '/campaign_statistic/graphical_statistics';

// city
export const GET_LIST_PROVINCES = '/city/list';

// campaign lich viet
export const GET_LIST_CAMPAIGN_LICH_VIET = '/campaigns/list-lichviet';

// common
export const GET_TOPIC = '/common/get_topics'; // version: type = 2, topic: type = 3
export const GET_TOKEN_TO_UPLOAD = '/common/get-token-to-upload';
export const GET_LIST_BANNER_PAGE = '/common/get_banners_page';
export const GET_LIST_POPUP_PAGE = '/common/get_popups_page';

// popup
export const GET_LIST_POPUPS = '/popups/list';
export const GET_POPUP_DETAIL = '/ajax/popups/detail';
export const CREATE_UPDATE_POPUP = '/ajax/popups/update';
export const DELETE_POPUP = '/ajax/popups/delete';
export const POPUP_STATUS_CHANGE = '/ajax/popups/change';

//audience
export const GET_LIST_AUDIENCE = '/audiences/list';

// banner
export const GET_LIST_BANNERS = '/banners/list';
export const GET_BANNER_DETAIL = '/ajax/banners/detail';
export const CREATE_UPDATE_BANNER = '/ajax/banners/update';
export const DELETE_BANNER = '/ajax/banners/delete';
export const BANNER_STATUS_CHANGE = '/ajax/banners/change';

// notification
export const GET_LIST_NOTIFICATIONS = '/notifications/list';
export const GET_NOTIFICATION_DETAIL = '/ajax/notifications/detail';
export const CREATE_UPDATE_NOTIFICATION = '/ajax/notifications/update';
export const DELETE_NOTIFICATION = '/ajax/notifications/delete';

// notification statistic
export const GET_DIMENSIONS_NOTIFICATION = '/notification_statistic/dimensions';
export const GET_METRICS_NOTIFICATION = '/notification_statistic/metrics';
export const GET_LICH_VIET_CAMPAIGNS = '/common/get_lichviet_campaigns';
export const GET_NOTIFICATION_TYPES = '/common/get_notification_types';
export const GET_NOTIFICATION_AUDIENCES = '/common/get_audiences';
export const GET_NOTIFICATIONS = '/common/get_notifications';
export const GET_NOTIFICATION_LABELS = '/common/get_notification_labels';
export const GET_DATA_NOTIFICATION_STATISTICS = '/notification_statistic/data_statistics';
export const GET_GRAPHICAL_NOTIFICATION_STATISTICS = '/notification_statistic/graphical_statistics';
